<template>
  <Layout>
    <template v-if="this.$route.name == 'add-live-event-script'">
      <PageHeader :title="title1" :items="items"></PageHeader>
    </template>
    <template v-else>
      <PageHeader :title="title2" :items="items"></PageHeader>
    </template>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" id="medinext">
            <b-form enctype="multipart/form-data" ref="promotion">
              <div class="row">
                <b-form-group class="col-lg-12 col-md-12 col-sm-12">
                  <label for="communities">Live Event</label>
                  <multiselect
                    id="input-3"
                    v-model="form.live_event_id"
                    @search-change="fetchLiveEvent"
                    :options="getLiveEvents"
                    :multiple="false"
                    track-by="id"
                    label="title"
                    placeholder="Type here to search"
                    :class="{
                              'is-invalid':
                                submitted && $v.form.live_event_id.$invalid,
                            }"
                  >
                    <span slot="noOptions">
                      Type here to search
                    </span>
                  </multiselect>
                </b-form-group>
                <!-- <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                  <label for="total_reach"
                    >Registration Count <span style="color: red">*</span></label
                  >
                  <b-form-input
                    type="number"
                    min="1"
                    id="total_reach"
                    placeholder="Enter Target Reach"
                    v-model="form.total_registration_count"
                    :class="{
                      'is-invalid': submitted && $v.form.total_registration_count.$invalid,
                    }"
                  ></b-form-input>
                  <div
                    v-if="submitted && !$v.form.total_registration_count.required"
                    class="invalid-feedback"
                  >
                    Target Reach is required.
                  </div>
                </b-form-group> -->

                <!-- <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                  <label for="session-date-time"
                    >Start DateTime <span style="color: red"> *</span></label
                  >
                  <date-picker
                    type="datetime"
                    v-model="start_datetime"
                    placeholder="yyyy-mm-dd hh:mm:ss"
                    :confirm="true"
                    :disabled-date="disabledDate"
                  ></date-picker>
                </b-form-group> -->
                <!-- <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                  <label for="session-end-time"
                    >End DateTime <span style="color: red"> *</span></label
                  >
                  <date-picker
                    type="datetime"
                    v-model="end_datetime"
                    placeholder="yyyy-mm-dd hh:mm:ss"
                    :confirm="true"
                    :disabled-date="disableStartDate"
                  ></date-picker>
                </b-form-group> -->
              </div>
              <div class="row">
                  <div class="col-12">
                    <!-- <div class="d-flex align-items-center"> -->
                      <!-- <i class="mdi mdi-file-plus-outline mr-2"></i> -->
                      <!-- <h6 class="mb-0">Add Speciality</h6> -->
                    <!-- </div> -->
                    <b-form-group class="my-2">
                      
                      
                      <div
                        class="row"
                        v-for="(val, index) in form.specialities"
                        :key="index"
                      >
                      <!-- {{ val.speciality_id }} -->
                        <!-- Speciality Dropdown -->
                        <div class="col-6">
                          <b-form-group>
                            <label for="speciality-input">Speciality <span style="color: red">*</span></label>
                            <multiselect
                              v-model="val.speciality_id"
                              @search-change="fetchSpeciality"
                              :options="speciality"
                              :multiple="false"
                              track-by="id"
                              label="title"
                              :class="{
                                'is-invalid':
                                  submitted && $v.val.speciality_id.$invalid,
                              }"
                              placeholder="Type here to search"
                            >
                              <span slot="noOptions">
                                Type here to search
                              </span>
                            </multiselect>
                          </b-form-group>
                        </div>

                        <!-- Count Input -->
                        <div class="col-2">
                          <b-form-group>
                            <label for="speciality-input">Register Member Count: <span style="color: red">*</span></label>
                            <b-form-input
                              type="number"
                              v-model="val.count"
                              placeholder="Enter Register Member count"
                              min="0"
                            ></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="col-2">
                          <b-form-group>
                            <label for="speciality-input">Attendees Count: <span style="color: red">*</span></label>
                            <b-form-input
                              type="number"
                              v-model="val.attendees_count"
                              placeholder="Enter Attendees Member count"
                              min="0"
                            ></b-form-input>
                          </b-form-group>
                        </div>

                        <!-- Add/Remove Buttons -->
                        <div class="col-2" style="margin:auto">
                          <b-button
                            variant="success"
                            class="mr-3 btn-sm"
                            :disabled="!val.speciality_id"
                            @click.prevent="addSpeciality(index)"
                          >+</b-button>

                          <b-button
                            variant="danger"
                            class="btn-sm"
                            @click.prevent="removeSpeciality(index)"
                          >-</b-button>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
              </div>
              <!-- <div class="row">
                <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                  <label for="data_filter_id"
                    >Data Filter <span style="color: red">*</span></label
                  >
                  <b-form-select
                    id="data_filter_id"
                    :options="getDataFilter"
                    value-field="id"
                    text-field="name"
                    v-model="form.data_filter_id"
                    :class="{
                      'is-invalid':
                        submitted && $v.form.data_filter_id.$invalid,
                    }"
                    :disabled="$route.name == 'edit-live-event-script' ? true : false"
                  >
                  </b-form-select>
                  <div
                    v-if="submitted && !$v.form.data_filter_id.required"
                    class="invalid-feedback"
                  >
                    Data Filter is required.
                  </div>
                </b-form-group>
                <b-form-group class="col-12">
                  <div style="display: flex; gap: 10px; padding: 2px 0">
                    <b-form-checkbox v-model="form.is_active"
                      >Is Active</b-form-checkbox
                    >
                  </div>
                </b-form-group>
              </div> -->
              <b-button
                type="submit"
                variant="primary"
                class="mr-2"
                @click.prevent="submitData"
              >
                <span v-if="this.$route.name == 'add-live-event-script'"
                  >Save Data</span
                >
                <span v-else>Update Data</span>
              </b-button>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import promotionMixin from "../../../mixins/ModuleJs/live_event_script";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
// import DatePicker from "vue2-datepicker";

export default {
  data() {
    return {
      submitted: false,
      title1: "Add Live Event Script",
      title2: "Edit Live Event Script",
      items: [
        {
          text: "List",
          href: "/live-event-script",
        },
        {
          text: "Data",
        },
      ],
    };
  },
  mixins: [MixinRequest, promotionMixin],
  components: {
    Layout,
    PageHeader,
    Multiselect,
    // DatePicker,
  },
  validations: {
    form: {
      // total_registration_count: { required },
      live_event_id: { required },
    },
  },
};
</script>
